import { useEffect } from 'react';
import urlTemplate from 'url-template';
import type {
  LngAllocationsForLsoParams,
  LngAllocationsForLsoResponse,
} from 'src/apis/lng-marketing/types';
import type { LngMarketingRootRequest } from 'src/apis/lng-marketing/use-lng-marketing-root';
import { useAxios } from 'src/hooks/use-axios';

type HookOptions = {
  lngMarketingRoot: LngMarketingRootRequest;
  params: LngAllocationsForLsoParams;
};

type ExecuteOptions = {
  url: string;
  params: LngAllocationsForLsoParams;
};

export function useLngAllocationsForLso({
  lngMarketingRoot,
  params,
}: HookOptions) {
  const lngAllocations = useAxios(
    (axios, baseConfig, { url, params }: ExecuteOptions) =>
      axios.request<LngAllocationsForLsoResponse>({
        ...baseConfig,
        url,
        params,
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    if (!lngMarketingRoot.response) return;

    const offersLink =
      lngMarketingRoot.response.data._links.getAllocationsOverviewForLso!; // we are checking for the link in the parent component

    // prefer private offers if available
    const url = urlTemplate.parse(offersLink.href).expand({});

    lngAllocations.execute({
      url,
      params,
    });
    // oxlint-disable-next-line exhaustive-deps
  }, [lngMarketingRoot.response, params]);

  return lngAllocations;
}

export type LngAllocationsForLsoRequest = ReturnType<
  typeof useLngAllocationsForLso
>;
